import {
  Sliders,
  Users,
  UserPlus,
  ChevronsUp,
  DollarSign,
  FileText,
  Grid,
  TrendingUp,
  PieChart,
  Activity,
  ShoppingBag,
  Target,
  Truck,
} from 'react-feather';

/**
 * Sprint 2 salesperson sidebar.
 *
 * To keep the sidebar usable we only surface a handful of entries at the top
 * level (the daily-driver views). Everything else is grouped into collapsible
 * dropdown categories ("Försäljning", "Fakturering", "Leverans", "Övrigt") so
 * the menu stays short and scannable. The `href` on a category is only used to
 * auto-expand the dropdown when the user is already on one of its sub-routes.
 */

const forsaljningCategory = {
  href: '/salesperson/crm',
  title: 'Försäljning',
  icon: TrendingUp,
  children: [
    {
      href: '/salesperson/crm/pipeline',
      title: 'Pipeline',
      icon: TrendingUp,
    },
    {
      href: '/salesperson/crm/prospekt',
      title: 'Prospekt',
      icon: Target,
    },
    {
      href: '/salesperson/crm/abonnemang',
      title: 'Abonnemang',
      icon: ShoppingBag,
    },
    {
      href: '/salesperson/proposal',
      title: 'Proposals',
      icon: ChevronsUp,
    },
    {
      href: '/salesperson/crm/retention',
      title: 'Retention',
      icon: Activity,
    },
    {
      href: '/salesperson/crm/aktivitet',
      title: 'Möten & aktiviteter',
      icon: Activity,
    },
    {
      href: '/salesperson/crm/arr-budget',
      title: 'ARR mot budget',
      icon: TrendingUp,
    },
  ],
};

const faktureringCategory = {
  href: '/salesperson/invoices',
  title: 'Fakturering',
  icon: DollarSign,
  children: [
    {
      href: '/salesperson/invoices',
      title: 'Fakturor',
      icon: DollarSign,
    },
    {
      href: '/salesperson/fakturalista',
      title: 'Fakturalista',
      icon: FileText,
    },
  ],
};

const leveransCategory = {
  href: '/salesperson/leverans',
  title: 'Leverans',
  icon: Truck,
  children: [
    {
      href: '/salesperson/leverans/kundlista',
      title: 'Kundlista',
      icon: Users,
    },
    {
      href: '/salesperson/leads',
      title: 'Kundförfrågningar',
      icon: UserPlus,
    },
  ],
};

const ovrigtCategory = {
  href: '/salesperson/produkter',
  title: 'Övrigt',
  icon: Grid,
  children: [
    {
      href: '/salesperson/sites',
      title: 'Landningssidor',
      icon: Grid,
    },
    {
      href: '/salesperson/hemsidor',
      title: 'Hemsidor',
      icon: Grid,
    },
    {
      href: '/salesperson/client',
      title: 'Inlogg kunder',
      icon: Users,
    },
    {
      href: '/salesperson/users',
      title: 'Användare (legacy)',
      icon: Users,
    },
  ],
};

const mainSection = {
  title: '',
  pages: [
    {
      href: '/salesperson/dashboard/default',
      title: 'Dashboard',
      icon: Sliders,
    },
    {
      href: '/salesperson/crm/saljardashboard',
      title: 'Min dashboard',
      icon: PieChart,
    },
    forsaljningCategory,
    faktureringCategory,
    leveransCategory,
    ovrigtCategory,
  ],
};

const navItems = [mainSection];

export default navItems;
